import { Resource } from "@design-system/Resource/Resource";

type Props = {
  name: string;
  subtext?: string;
  domain?: string;
  skipLogo?: boolean;
  signedLogoUrl?: string;
};

export const CompanyCell = ({
  name,
  subtext,
  domain,
  skipLogo,
  signedLogoUrl,
}: Props) => {
  return (
    <Resource
      key={domain}
      name={name}
      subtext={subtext}
      domain={domain}
      skipLogo={skipLogo}
      signedLogoUrl={signedLogoUrl}
    />
  );
};
